import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/locker/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/locker/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/locker/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/locker/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/locker/Delete',
    method: 'delete',
    data,
  })
}

export function showExcel(data) {
  return request({
    url: '/locker/lockerExcel',
    method: 'post',
    data,
  })
}
